import type { DataNode } from 'antd/es/tree';

export const isStringTitle = (title: unknown): title is string => {
  return typeof title === 'string';
};

export const getNodeTitle = (node: DataNode): string => {
  if (isStringTitle(node.title)) {
    return node.title;
  }
  return '';
};

export const getNodeKey = (node: DataNode): string => {
  return String(node.key);
};

export const getNodeDescription = (node: DataNode): string | undefined => {
  const desc = (node as { description?: unknown }).description;
  return typeof desc === 'string' ? desc : undefined;
};
